define(["./nodeCommandsModule"], function (nodeCommandsModule) {
    "use strict";

    return nodeCommandsModule.service("nodeCommandPermissionGroupDetails", [
        "$state",
        function ($state) {
            return function (selection) {
                if (selection && selection.length > 0) {
                    var url = $state.href("r2.configParamsPermissionGroupDetails", {
                        permissionGroupId: selection[0].id
                    });
                    window.open(url, "_blank");
                }
            };
        }
    ]);
});